// import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import { mapState } from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store';

import 'vuetify/dist/vuetify.min.css';
import './style/style.sass';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueCookies);

Vue.use(Vuetify);

new Vue({
  store,
  router,
  vuetify: new Vuetify({
    theme: {
      dark: false,
      themes: {
        light: {
          primary: '#28cde1',
        },
      },
    },
  }),
  methods: {
    checkPeriodically() {
      if (this.$root.$route.path.includes('login')) {
        return;
      }
      const interval = setInterval(async () => {
        const token = this.$cookies.get('accessToken');
        await store.dispatch('user/VerifyTokenEmailSave', token);
        if (!this.verifyTokenEmail) {
          // eslint-disable-next-line no-alert
          alert('You have been signed out. Please login again');
          this.$router.push('/login');
          clearInterval(interval);
        }
      }, 600000);
    },
  },
  async created() {
    const token = this.$cookies.get('accessToken');
    if (token) {
      await store.dispatch('user/VerifyTokenEmailSave', token);
      if (!this.verifyTokenEmail) {
        this.$router.push('/login');
      } else {
        await store.dispatch('user/saveUserStore', this.verifyTokenEmail);
      }
    } else {
      const checkPatch = this.$root.$route.path.includes('successLogin') || this.$root.$route.path.includes('errorLogin');
      if (!checkPatch) {
        router.push('/login');
      }
    }
    this.checkPeriodically();
  },
  render: (hyperscript) => hyperscript(App),
  computed: {
    ...mapState('user', ['verifyTokenEmail']),
  },
}).$mount('#app');
